import React from 'react';

export const WidgetsImg = () => {
  return (
    <svg
      width="483"
      height="339"
      viewBox="0 0 483 339"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_dd_558_59087)">
        <rect
          width="132.729"
          height="133.076"
          rx="8"
          transform="matrix(1 0 0.000530398 -1 26 302)"
          fill="white"
        />
      </g>
      <rect x="26" y="185.558" width="131.899" height="0.831726" fill="#E5E7EB" />
      <rect x="26" y="284.534" width="131.899" height="0.831718" fill="#E5E7EB" />
      <rect x="31.3677" y="176.409" width="43.1368" height="3.3269" rx="1.66345" fill="#D1D4DC" />
      <rect x="65.3794" y="201.361" width="53.9211" height="3.3269" rx="1.66345" fill="#E5E7EB" />
      <rect x="31.3677" y="224.649" width="55.5802" height="3.3269" rx="1.66345" fill="#7EC4F6" />
      <rect x="118.471" y="224.649" width="34.0117" height="3.3269" rx="1.66345" fill="#E5E7EB" />
      <rect x="31.3677" y="244.611" width="37.33" height="3.32691" rx="1.66346" fill="#7EC4F6" />
      <rect x="118.471" y="244.611" width="34.0117" height="3.32691" rx="1.66346" fill="#E5E7EB" />
      <rect x="31.3677" y="264.572" width="43.1368" height="3.3269" rx="1.66345" fill="#7EC4F6" />
      <rect x="136.721" y="264.572" width="15.7615" height="3.3269" rx="1.66345" fill="#E5E7EB" />
      <rect x="31.3677" y="234.63" width="46.4551" height="3.3269" rx="1.66345" fill="#7EC4F6" />
      <rect x="121.789" y="234.63" width="30.6935" height="3.3269" rx="1.66345" fill="#E5E7EB" />
      <rect x="31.3677" y="254.592" width="50.6028" height="3.3269" rx="1.66345" fill="#7EC4F6" />
      <rect x="113.494" y="254.592" width="38.9891" height="3.3269" rx="1.66345" fill="#E5E7EB" />
      <rect x="30.9775" y="274.553" width="65.5348" height="3.3269" rx="1.66345" fill="#7EC4F6" />
      <rect x="128.426" y="274.553" width="24.0571" height="3.3269" rx="1.66345" fill="#E5E7EB" />
      <rect x="121.399" y="290.356" width="32.3526" height="6.65381" rx="3.3269" fill="#E5E7EB" />
      <rect x="111.834" y="290.747" width="6.63644" height="6.65382" rx="3.31822" fill="#CABFFD" />
      <g filter="url(#filter1_dd_558_59087)">
        <rect
          width="132.729"
          height="133.076"
          rx="8"
          transform="matrix(1 0 0.000530398 -1 25.5 146.076)"
          fill="white"
        />
      </g>
      <rect x="25.5" y="29.6345" width="131.899" height="0.831726" fill="#E5E7EB" />
      <rect x="25.5" y="128.61" width="131.899" height="0.831726" fill="#E5E7EB" />
      <rect x="30.4775" y="20.8766" width="55.5802" height="3.3269" rx="1.66345" fill="#D1D4DC" />
      <rect x="30.4775" y="37.1201" width="121.115" height="3.3269" rx="1.66345" fill="#E5E7EB" />
      <rect x="30.4775" y="47.1008" width="65.5348" height="3.3269" rx="1.66345" fill="#E5E7EB" />
      <rect x="120.899" y="134.432" width="32.3526" height="6.65381" rx="3.3269" fill="#E5E7EB" />
      <rect x="111.334" y="134.823" width="6.63644" height="6.65382" rx="3.31822" fill="#FF9457" />
      <path
        d="M36.6748 92.509C44.0072 92.509 40.9054 90.6376 47.9322 90.6376C55.2646 90.6376 57.9684 94.0685 65.3008 94.0685C72.3277 94.0685 70.5124 90.6376 77.8448 90.6376C85.1772 90.6376 83.378 92.509 90.7104 92.509C97.7373 92.509 101.068 94.0685 108.401 94.0685C115.733 94.0685 117.456 90.6376 124.483 90.6376C131.815 90.6376 130.177 87.8305 137.509 87.8305C144.536 87.8305 144.651 81.5926 151.983 81.5926"
        stroke="#31C48D"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M34.186 119.02C41.5184 119.02 41.5184 114.072 48.5453 114.072C55.8777 114.072 55.8777 106.154 63.2101 106.154C70.2369 106.154 70.2369 101.205 77.5693 101.205C84.9017 101.205 84.9017 94.2772 92.2341 94.2772C99.2609 94.2772 99.261 85.3696 106.593 85.3696C113.926 85.3696 113.359 83.9 120.386 83.9C127.718 83.9 128.285 74.4827 135.617 74.4827C142.644 74.4827 143.705 69.7338 149.494 64.1263"
        stroke="#0078D4"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <g filter="url(#filter2_dd_558_59087)">
        <rect
          width="132.729"
          height="133.076"
          rx="8"
          transform="matrix(1 0 0.000530398 -1 171.892 146.467)"
          fill="white"
        />
      </g>
      <rect x="180.188" y="58.3043" width="4.97733" height="4.99035" rx="2.48866" fill="#6875F5" />
      <rect x="180.188" y="73.2754" width="4.97733" height="4.99036" rx="2.48866" fill="#B4C6FC" />
      <rect x="180.188" y="88.2465" width="4.97733" height="4.99035" rx="2.48866" fill="#0078D4" />
      <rect x="180.188" y="103.218" width="4.97733" height="4.99035" rx="2.48866" fill="#009FF9" />
      <rect x="180.188" y="118.189" width="4.97733" height="4.99036" rx="2.48866" fill="#7EC4F6" />
      <rect x="172.722" y="29.6345" width="131.899" height="0.831726" fill="#E5E7EB" />
      <rect x="172.722" y="128.61" width="131.899" height="0.831726" fill="#E5E7EB" />
      <rect x="177.699" y="20.8766" width="43.9664" height="3.3269" rx="1.66345" fill="#D1D4DC" />
      <rect x="189.312" y="59.136" width="90.4215" height="3.3269" rx="1.66345" fill="#E5E7EB" />
      <rect x="189.312" y="74.1071" width="65.5348" height="3.3269" rx="1.66345" fill="#E5E7EB" />
      <rect x="189.312" y="89.0781" width="90.4215" height="3.32691" rx="1.66346" fill="#E5E7EB" />
      <rect x="189.312" y="104.049" width="103.694" height="3.3269" rx="1.66345" fill="#E5E7EB" />
      <rect x="189.312" y="119.02" width="72.1713" height="3.3269" rx="1.66345" fill="#E5E7EB" />
      <rect x="268.121" y="134.432" width="32.3526" height="6.65381" rx="3.3269" fill="#E5E7EB" />
      <rect x="258.556" y="134.823" width="6.63644" height="6.65381" rx="3.31822" fill="#104C8B" />
      <path
        d="M297.985 39.1746H298.2C300.41 39.1746 302.2 40.9655 302.2 43.1746V45.1553C302.2 47.3645 300.41 49.1553 298.2 49.1553H297.985V39.1746Z"
        fill="#E6F5FF"
      />
      <path d="M280.564 39.1746H297.985V49.1553H280.564V39.1746Z" fill="#7EC4F6" />
      <rect x="265.632" y="39.1746" width="19.0798" height="9.98071" fill="#009FF9" />
      <path d="M245.723 39.1746H265.632V49.1553H245.723V39.1746Z" fill="#0078D4" />
      <path d="M212.541 39.1746H245.723V49.1553H212.541V39.1746Z" fill="#8DA2FB" />
      <path
        d="M176.87 43.1746C176.87 40.9655 178.66 39.1746 180.87 39.1746H212.54V49.1553H180.87C178.66 49.1553 176.87 47.3645 176.87 45.1553V43.1746Z"
        fill="#5850EC"
      />
      <g filter="url(#filter3_dd_558_59087)">
        <rect
          width="132.729"
          height="133.076"
          rx="8"
          transform="matrix(1 0 0.000530398 -1 323.701 146.467)"
          fill="white"
        />
      </g>
      <rect x="324.53" y="29.6345" width="131.899" height="0.831726" fill="#E5E7EB" />
      <rect x="324.53" y="128.61" width="131.899" height="0.831726" fill="#E5E7EB" />
      <rect x="329.507" y="20.8766" width="48.1142" height="3.3269" rx="1.66345" fill="#D1D4DC" />
      <rect x="336.144" y="48.3236" width="107.842" height="3.3269" rx="1.66345" fill="#E5E7EB" />
      <rect x="366.008" y="37.5112" width="49.7733" height="3.3269" rx="1.66345" fill="#E5E7EB" />
      <rect x="419.929" y="134.432" width="32.3526" height="6.65381" rx="3.3269" fill="#E5E7EB" />
      <rect x="410.365" y="134.823" width="6.63644" height="6.65381" rx="3.31822" fill="#31C48D" />
      <path
        d="M336.144 84.7609C336.144 82.5518 337.935 80.7609 340.144 80.7609H347.076C349.285 80.7609 351.076 82.5518 351.076 84.7609V119.02H336.144V84.7609Z"
        fill="#009FF9"
      />
      <path
        d="M367.667 78.1071C367.667 75.898 369.458 74.1071 371.667 74.1071H377.769C379.979 74.1071 381.769 75.898 381.769 78.1071V119.02H367.667V78.1071Z"
        fill="#009FF9"
      />
      <path
        d="M398.361 71.4533C398.361 69.2442 400.152 67.4533 402.361 67.4533H409.293C411.502 67.4533 413.293 69.2442 413.293 71.4533V119.02H398.361V71.4533Z"
        fill="#009FF9"
      />
      <path
        d="M429.884 68.1264C429.884 65.9173 431.675 64.1264 433.884 64.1264H439.986C442.195 64.1264 443.986 65.9173 443.986 68.1264V119.02H429.884V68.1264Z"
        fill="#009FF9"
      />
      <g filter="url(#filter4_dd_558_59087)">
        <rect
          width="132.729"
          height="133.076"
          rx="8"
          transform="matrix(1 0 0.000530398 -1 175 302)"
          fill="white"
        />
      </g>
      <rect x="175.83" y="185.167" width="131.899" height="0.831726" fill="#E5E7EB" />
      <rect x="175.83" y="284.143" width="131.899" height="0.831726" fill="#E5E7EB" />
      <rect x="180.807" y="176.409" width="48.1142" height="3.3269" rx="1.66345" fill="#D1D4DC" />
      <rect x="187.443" y="203.856" width="107.842" height="3.3269" rx="1.66345" fill="#E5E7EB" />
      <rect x="217.307" y="193.044" width="49.7733" height="3.3269" rx="1.66345" fill="#E5E7EB" />
      <rect x="187.443" y="259.582" width="4.97733" height="4.99036" rx="2.48866" fill="#6875F5" />
      <rect x="187.443" y="274.553" width="4.97733" height="4.99036" rx="2.48866" fill="#B4C6FC" />
      <rect x="196.568" y="260.414" width="90.4215" height="3.3269" rx="1.66345" fill="#E5E7EB" />
      <rect x="196.568" y="275.385" width="65.5348" height="3.3269" rx="1.66345" fill="#E5E7EB" />
      <rect x="271.229" y="289.965" width="32.3526" height="6.65381" rx="3.3269" fill="#E5E7EB" />
      <rect x="261.664" y="290.356" width="6.63644" height="6.65381" rx="3.31822" fill="#FEAEB6" />
      <rect
        x="200.716"
        y="248.77"
        width="2.49519"
        height="13.2729"
        transform="rotate(90 200.716 248.77)"
        fill="#009FF9"
      />
      <path
        d="M200.716 242.116L200.716 248.77L187.443 248.77L187.443 242.116L200.716 242.116Z"
        fill="#0078D4"
      />
      <path
        d="M200.715 227.112L200.715 242.116L187.443 242.116L187.443 227.112L200.715 227.112Z"
        fill="#8DA2FB"
      />
      <path
        d="M196.715 214.669C198.924 214.669 200.715 216.46 200.715 218.669L200.715 227.111L187.443 227.111L187.443 218.669C187.443 216.46 189.234 214.669 191.443 214.669L196.715 214.669Z"
        fill="#6875F5"
      />
      <rect
        x="224.773"
        y="249.601"
        width="1.66344"
        height="13.2729"
        transform="rotate(90 224.773 249.601)"
        fill="#009FF9"
      />
      <path
        d="M224.773 244.611L224.773 249.601L211.501 249.601L211.501 244.611L224.773 244.611Z"
        fill="#0078D4"
      />
      <path
        d="M224.772 233.699L224.772 244.611L211.5 244.611L211.5 233.699L224.772 233.699Z"
        fill="#8DA2FB"
      />
      <path
        d="M220.772 224.649C222.981 224.649 224.772 226.44 224.772 228.649L224.772 233.699L211.5 233.699L211.5 228.649C211.5 226.44 213.291 224.649 215.5 224.649L220.772 224.649Z"
        fill="#6875F5"
      />
      <rect
        x="248.831"
        y="249.393"
        width="1.87138"
        height="13.2729"
        transform="rotate(90 248.831 249.393)"
        fill="#009FF9"
      />
      <path
        d="M248.831 243.779L248.831 249.393L235.558 249.393L235.558 243.779L248.831 243.779Z"
        fill="#0078D4"
      />
      <path
        d="M248.829 231.503L248.829 243.779L235.557 243.779L235.557 231.503L248.829 231.503Z"
        fill="#8DA2FB"
      />
      <path
        d="M244.829 221.323C247.038 221.323 248.829 223.113 248.829 225.323L248.829 231.503L235.557 231.503L235.557 225.323C235.557 223.113 237.348 221.323 239.557 221.323L244.829 221.323Z"
        fill="#6875F5"
      />
      <rect
        x="272.888"
        y="248.77"
        width="2.49519"
        height="13.2729"
        transform="rotate(90 272.888 248.77)"
        fill="#009FF9"
      />
      <path
        d="M272.888 242.947L272.888 248.77L259.615 248.77L259.615 242.947L272.888 242.947Z"
        fill="#0078D4"
      />
      <path
        d="M272.886 229.308L272.886 242.947L259.615 242.947L259.615 229.308L272.886 229.308Z"
        fill="#8DA2FB"
      />
      <path
        d="M268.886 217.996C271.095 217.996 272.886 219.787 272.886 221.996L272.886 229.307L259.615 229.307L259.615 221.996C259.615 219.787 261.405 217.996 263.615 217.996L268.886 217.996Z"
        fill="#6875F5"
      />
      <rect
        x="296.945"
        y="249.601"
        width="1.66344"
        height="13.2729"
        transform="rotate(90 296.945 249.601)"
        fill="#009FF9"
      />
      <path
        d="M296.945 246.274L296.945 249.601L283.672 249.601L283.672 246.274L296.945 246.274Z"
        fill="#0078D4"
      />
      <path
        d="M296.943 236.993L296.943 246.274L283.672 246.274L283.672 236.993L296.943 236.993Z"
        fill="#8DA2FB"
      />
      <path
        d="M292.943 229.64C295.152 229.64 296.943 231.431 296.943 233.64L296.943 236.992L283.672 236.992L283.672 233.64C283.672 231.431 285.463 229.64 287.672 229.64L292.943 229.64Z"
        fill="#6875F5"
      />
      <g filter="url(#filter5_dd_558_59087)">
        <rect
          width="132.729"
          height="133.076"
          rx="8"
          transform="matrix(1 0 0.000530398 -1 324.299 302)"
          fill="white"
        />
      </g>
      <path
        d="M392.299 220H449.299C451.508 220 453.299 221.791 453.299 224V226C453.299 228.209 451.508 230 449.299 230H392.299V220Z"
        fill="#E5E7EB"
      />
      <path
        d="M328.299 224C328.299 221.791 330.09 220 332.299 220H394.299V230H332.299C330.09 230 328.299 228.209 328.299 226V224Z"
        fill="#0078D4"
      />
      <rect x="324.191" y="185.558" width="131.899" height="0.831726" fill="#E5E7EB" />
      <rect x="329.559" y="176.409" width="43.1368" height="3.3269" rx="1.66345" fill="#D1D4DC" />
      <rect x="329.299" y="245" width="55.5802" height="3.3269" rx="1.66345" fill="#7EC4F6" />
      <rect x="416.403" y="245" width="34.0117" height="3.3269" rx="1.66345" fill="#31C48D" />
      <rect x="329.299" y="265" width="63" height="3" rx="1.5" fill="#7EC4F6" />
      <rect x="416.403" y="264.961" width="34.0117" height="3.32691" rx="1.66346" fill="#F97386" />
      <rect x="329.299" y="254.981" width="46.4551" height="3.3269" rx="1.66345" fill="#7EC4F6" />
      <rect x="419.721" y="254.981" width="30.6935" height="3.3269" rx="1.66345" fill="#31C48D" />
      <rect x="325.129" y="284.143" width="131.899" height="0.831726" fill="#E5E7EB" />
      <rect x="420.528" y="289.965" width="32.3526" height="6.65381" rx="3.3269" fill="#E5E7EB" />
      <rect x="410.963" y="290.356" width="6.63644" height="6.65381" rx="3.31822" fill="#8F959F" />
      <rect x="365.299" y="202" width="53.9211" height="3.3269" rx="1.66345" fill="#E5E7EB" />
      <defs>
        <filter
          id="filter0_dd_558_59087"
          x="1.00439"
          y="155.924"
          width="182.791"
          height="183.076"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="8" />
          <feGaussianBlur stdDeviation="5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.215686 0 0 0 0 0.254902 0 0 0 0 0.317647 0 0 0 0.04 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_558_59087" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="12" />
          <feGaussianBlur stdDeviation="12.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.215686 0 0 0 0 0.254902 0 0 0 0 0.317647 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_558_59087"
            result="effect2_dropShadow_558_59087"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_558_59087"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_dd_558_59087"
          x="0.504395"
          y="6.10352e-05"
          width="182.791"
          height="183.076"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="8" />
          <feGaussianBlur stdDeviation="5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.215686 0 0 0 0 0.254902 0 0 0 0 0.317647 0 0 0 0.04 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_558_59087" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="12" />
          <feGaussianBlur stdDeviation="12.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.215686 0 0 0 0 0.254902 0 0 0 0 0.317647 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_558_59087"
            result="effect2_dropShadow_558_59087"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_558_59087"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_dd_558_59087"
          x="146.896"
          y="0.391174"
          width="182.791"
          height="183.076"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="8" />
          <feGaussianBlur stdDeviation="5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.215686 0 0 0 0 0.254902 0 0 0 0 0.317647 0 0 0 0.04 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_558_59087" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="12" />
          <feGaussianBlur stdDeviation="12.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.215686 0 0 0 0 0.254902 0 0 0 0 0.317647 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_558_59087"
            result="effect2_dropShadow_558_59087"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_558_59087"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_dd_558_59087"
          x="298.705"
          y="0.391174"
          width="182.791"
          height="183.076"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="8" />
          <feGaussianBlur stdDeviation="5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.215686 0 0 0 0 0.254902 0 0 0 0 0.317647 0 0 0 0.04 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_558_59087" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="12" />
          <feGaussianBlur stdDeviation="12.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.215686 0 0 0 0 0.254902 0 0 0 0 0.317647 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_558_59087"
            result="effect2_dropShadow_558_59087"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_558_59087"
            result="shape"
          />
        </filter>
        <filter
          id="filter4_dd_558_59087"
          x="150.004"
          y="155.924"
          width="182.791"
          height="183.076"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="8" />
          <feGaussianBlur stdDeviation="5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.215686 0 0 0 0 0.254902 0 0 0 0 0.317647 0 0 0 0.04 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_558_59087" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="12" />
          <feGaussianBlur stdDeviation="12.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.215686 0 0 0 0 0.254902 0 0 0 0 0.317647 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_558_59087"
            result="effect2_dropShadow_558_59087"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_558_59087"
            result="shape"
          />
        </filter>
        <filter
          id="filter5_dd_558_59087"
          x="299.304"
          y="155.924"
          width="182.791"
          height="183.076"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="8" />
          <feGaussianBlur stdDeviation="5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.215686 0 0 0 0 0.254902 0 0 0 0 0.317647 0 0 0 0.04 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_558_59087" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="12" />
          <feGaussianBlur stdDeviation="12.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.215686 0 0 0 0 0.254902 0 0 0 0 0.317647 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_558_59087"
            result="effect2_dropShadow_558_59087"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_558_59087"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
